export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="w-full max-w-4xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-3">联系我们</h2>
          <p className="text-foreground-500 text-sm">你有猛料？欢迎投稿，一起吃瓜</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          <div className="bg-background-100 rounded-2xl p-6 border border-background-200/70 text-center hover:border-primary-300/50 transition-colors duration-200">
            <div className="w-14 h-14 mx-auto mb-4 rounded-2xl bg-primary-100 flex items-center justify-center">
              <i className="ri-mail-send-line text-2xl text-primary-600"></i>
            </div>
            <h3 className="font-heading text-lg text-foreground-900 mb-2">爆料投稿</h3>
            <p className="text-sm text-foreground-500 mb-4">
              如果你有独家内幕消息，欢迎通过邮件向我们投稿，一经采用将给予丰厚奖励。
            </p>
            <span className="inline-block text-sm text-primary-600 font-medium bg-primary-50 px-4 py-2 rounded-lg">
              tips@chigua123.com
            </span>
          </div>

          <div className="bg-background-100 rounded-2xl p-6 border border-background-200/70 text-center hover:border-accent-300/50 transition-colors duration-200">
            <div className="w-14 h-14 mx-auto mb-4 rounded-2xl bg-accent-100 flex items-center justify-center">
              <i className="ri-chat-smile-2-line text-2xl text-accent-600"></i>
            </div>
            <h3 className="font-heading text-lg text-foreground-900 mb-2">商务合作</h3>
            <p className="text-sm text-foreground-500 mb-4">
              广告投放、品牌推广、内容合作等商务需求，请发送邮件详谈合作方案。
            </p>
            <span className="inline-block text-sm text-accent-600 font-medium bg-accent-50 px-4 py-2 rounded-lg">
              biz@chigua123.com
            </span>
          </div>

          <div className="bg-background-100 rounded-2xl p-6 border border-background-200/70 text-center hover:border-secondary-300/50 transition-colors duration-200">
            <div className="w-14 h-14 mx-auto mb-4 rounded-2xl bg-secondary-100 flex items-center justify-center">
              <i className="ri-error-warning-line text-2xl text-secondary-600"></i>
            </div>
            <h3 className="font-heading text-lg text-foreground-900 mb-2">侵权申诉</h3>
            <p className="text-sm text-foreground-500 mb-4">
              如发现本站内容侵犯了您的合法权益，请发送相关证明材料，我们将在24小时内处理。
            </p>
            <span className="inline-block text-sm text-secondary-600 font-medium bg-secondary-50 px-4 py-2 rounded-lg">
              report@chigua123.com
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}